import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import DetailsCategory from './DetailsCategory';

const DetailsDescription = ({ fields, }) => {
  const classes = useStyles();
  return (
    <div className={classes.detailsDescription}>
      {fields.map((field) => (
        <DetailsCategory
          key={field.categoryName}
          {...field}
        />
      ))}
    </div>
  );
};

DetailsDescription.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string.isRequired,
    categoryName: PropTypes.string.isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string]))]),
    iconColor: PropTypes.string,
  })).isRequired,
};

DetailsDescription.defaultProps = {
  fields: [],
};

const useStyles = createUseStyles({
  detailsDescription: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '2em',
    '& .ReactCollapse--collapse': {
      transition: 'all 1s ease 0s',
    },
  },
});

export default DetailsDescription;

